import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AumicoCoreProvider } from '../../../../aumico-lib-core-fe/src/lib';
import { RoutesUtil } from '../util/RoutesUtil';
import { WorkflowArea } from '../enums/workflow-area.enum';
import { SubjectType } from '../enums/subject-type.enum';
import { SyncWorkflowRequestDto } from '../dtos/sync-workflow-request-dto.interface';
import { GetTasksOfProjectDto } from '../dtos/getTasksOfProjectDto';

@Injectable({
    providedIn: 'root',
})
export class SyncService {
    constructor(
        private http: HttpClient,
        private readonly coreProvider: AumicoCoreProvider,
        private routesUtil: RoutesUtil,
    ) {}

    syncProjectWorkflow(
        projectId: string,
        workflowArea: WorkflowArea,
        sync: boolean,
        subjectType?: SubjectType,
    ): Observable<GetTasksOfProjectDto> {
        const url = this.routesUtil.syncProjectWorkflow(projectId, subjectType === SubjectType.PERSON);
        const body: SyncWorkflowRequestDto = { workflowArea, sync };
        return this.http.put<GetTasksOfProjectDto>(url, body);
    }
}
